import React from 'react'
import {
  Comments,
  usePaginationState,
  useRecordComments,
} from '@therms/react-modules'

interface RecordCommentsProps {
  recordId: string
}

function CommentsTab({ recordId }: RecordCommentsProps) {
  const {
    recordsPerPage,
    setRecordsPerPage,
    setSkippedRecords,
    skippedRecords,
  } = usePaginationState(
    `rcrd_cmnt_${recordId.substring(recordId.length - 9)}`,
    [],
  )
  const { data, loading } = useRecordComments({
    pagination: { limit: recordsPerPage, skip: skippedRecords },
    recordId,
  })

  return (
    <div className="grow overflow-y-auto pb-sm">
      <Comments
        checkCanEditComment={() => false}
        comments={data?.comments}
        commentsPerPage={recordsPerPage}
        loading={loading}
        onCommentsPerPageChange={setRecordsPerPage}
        onPageClick={setSkippedRecords}
        skippedComments={skippedRecords}
        totalComments={data?.total}
      />
    </div>
  )
}

export { CommentsTab }
